import React, { Component } from 'react'
import { connect } from 'react-redux'
import { toggleStudentAccessToSection } from '../../actions/sections'
import Button from '../uiKit/Button'
import FeatureModalSelectControl from '../featureModals/FeatureModalSelectControl'
import Icon from '../misc/Icons'
import SectionMarker from '../uiKit/SectionMarker'


class ActivateELearningGCCodes extends Component {

	constructor(){
		super()				
		this.handleBackgroundClick=this.handleBackgroundClick.bind(this)
		this.sendAnnouncement=this.sendAnnouncement.bind(this)
		
		this.state=({
			submitLoading:false,
			textAreaValue:"Before next class, please click the link below to register with Plickers. \n\nWhen we use Plickers E-Learning in class, you can visit my.plickers.com on your device to live!"
		
		})
	}

 	UNSAFE_componentWillMount() {
		document.body.style.overflowY='hidden' //prevent scrolling while modal is open
	}

 
	componentWillUnmount() {
		document.body.style.overflowY='' // overlay is not supported by firefox, so default to blank (auto style comes from css)
		document.body.style.overflowY='overlay' // overlay is to prevent windows scrollbars interacting with pagewidth
	}



	handleBackgroundClick(e){
		if (!this.state.submitLoading && e.target === e.currentTarget) this.props.dismissModal() //close modal is click outside modal
	}
	




	componentDidMount(){
		// if(window.analytics){
		// 	const userSegment=getUserSegment()
		// 	if(userSegment==='churnedPro'){
		// 		window.analytics.page('BackToSchoolModal',{couponName:'BTS2019-ChurnedPro'})
		// 	}else{
		// 		window.analytics.page('BackToSchoolModal',{couponName:'	BTS2019-ActiveMonthlyPro'})

		// 	}
		// }
	}
	


	sendAnnouncement(){
		this.props.dismissModal()
		this.props.showNotification('','Links Successfully Sent via Google Classroom','default')

	}




	// activateElearning(){
	// 	this.setState({submitLoading:true})
	// 	setTimeout(function() {
 //   			this.props.toggleStudentAccessToSection(this.props.section.id,true,this.props.user.id,this.state.coppaStudentsUnder13,this.state.coppaStudentsUSBased,this.state.coppaAcceptedConsent).then(()=>{
	// 			this.setState({toggleStudentAccessSubmitLoading:false})
	// 			document.body.style.overflowY='' // overlay is not supported by firefox, so default to blank (auto style comes from css)
	// 			document.body.style.overflowY='overlay' // overlay is to prevent windows scrollbars interacting with pagewidth
	// 			this.props.scrollToStudentSection()
	// 			this.props.dismissModal()	
					
	// 	})}.bind(this), 1000)
		
	// }



  
	
	render() {

		

		
			return (
				<div className='sectionHome-activateELearningWizardContainer' onClick={this.handleBackgroundClick}>				

					<div className='sectionHome-activateELearningWizard sectionHome-activateELearningWizard--shareGCCodes'>
						<div className='sectionHome-activateELearningWizard-header'>
							<SectionMarker section={this.props.section} type='circle' />
							<Icon name='chevron-right' />
							<div className='sectionHome-activateELearningWizard-header-label'>E-Learning Setup </div>
						</div>

						<div className='sectionHome-activateELearningWizard-title'>
							<div className='sectionHome-activateELearningWizard-title-text'>
								Share Registration Links via Google Classroom
							</div>
							<div className='sectionHome-activateELearningWizard-title-icon'>
								<Icon name='googleClassroomLogo' />
							</div>

						</div>

						<div className='sectionHome-activateELearningWizard-subtitle'>
							Send each student their secure device-registration link via a private Google Classroom announcement.

						</div>

						<div className='sectionHome-activateELearningWizard-announcementContainer'>
							<div className='sectionHome-activateELearningWizard-announcement-title'>
								 Announcement Message Text
							</div>
							<textarea
								className='sectionHome-activateELearningWizard-announcement-textarea'
								value={this.state.textAreaValue}
								onChange={(e)=>{this.setState({textAreaValue:e.target.value})}}
									
							/>
							<div className='sectionHome-activateELearningWizard-announcement-tip'>
								Tip: You can write your own the announcement message! 
							</div>
							<div className='sectionHome-activateELearningWizard-announcement-tip'>
								The student’s registration link will always be attached to the announcement.
							</div>
								
						</div>




						<div className='sectionHome-activateELearningWizard-closeBtn' onClick={this.handleBackgroundClick}>							
							<Icon name='circle-with-close' />
						</div>


						<button className='btn btn--xLarge sectionHome-activateELearningWizard-submitBtn btn--blue' type="submit" onClick={this.sendAnnouncement}>
								
							{!this.state.submitLoading &&	
								<React.Fragment>
									<div className='sectionHome-activateELearningWizard-submitBtn-primary'>
										Share Links via Google Classroom
									</div>									
									<div className='sectionHome-activateELearningWizard-submitBtn-secondary'>
										Press ENTER
									</div>									
								</React.Fragment>
							}

							{this.state.submitLoading &&
								<div className='sectionHome-activateELearningWizard-submitBtn-loadingSpinnerContainer'>
									<div className='sectionHome-activateELearningWizard-submitBtn-loadingSpinner' />
								</div>
							}

						</button>
						
					</div>
								
				</div>								
			)
		}
	}




export default ActivateELearningGCCodes